import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchVisitVideoTypes = async ({ visitId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (!!visitId) params.append("visit_id", visitId);

  const URL = `${__API_URL__}/api/photos/visit-video-types/web/?${params.toString()}`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useVisitVideoTypes = ({ visitId, enabled = true } = {}) => {
  return useQuery({
    queryKey: ["visit_video_types", visitId],
    queryFn: () => fetchVisitVideoTypes({ visitId }),
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
};

export default useVisitVideoTypes;
